export default function Pagination({ page, totalPages, onChange }) {
  if (totalPages <= 1) return null;
  return (
    <div className="mt-10 flex items-center justify-center gap-2" aria-label="Pagination">
      <button
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page <= 1}
        className="rounded-xl border border-line bg-white px-4 py-3 text-sm font-semibold text-dark transition hover:border-primary hover:text-primary disabled:cursor-not-allowed disabled:opacity-50"
      >
        Prev
      </button>
      {Array.from({ length: totalPages }, (_, index) => index + 1).map((item) => (
        <button key={item} onClick={() => onChange(item)} className={`grid h-11 w-11 place-items-center rounded-xl border text-sm font-semibold transition ${page === item ? "border-primary bg-primary text-white" : "border-line bg-white text-dark hover:border-primary hover:text-primary"}`}>
          {item}
        </button>
      ))}
      <button
        onClick={() => onChange(Math.min(totalPages, page + 1))}
        disabled={page >= totalPages}
        className="rounded-xl border border-line bg-white px-4 py-3 text-sm font-semibold text-dark transition hover:border-primary hover:text-primary disabled:cursor-not-allowed disabled:opacity-50"
      >
        Next
      </button>
    </div>
  );
}
